// @ts-nocheck
import {ConfEnv} from "../../../../config/config";
import publicRequest from "../../../../Infra/http/public.request";

export const getLotteryResourcesService = id => {
  return publicRequest.get(`${ConfEnv.BASE_URL}/lottery/${id}/resources`);
};
